import {fetchBaseQuery} from '@reduxjs/toolkit/dist/query/react';
import axios from 'axios';
import {toast} from 'react-toastify';

export const baseQuery = (url = import.meta.env.VITE_API_URL) => {
  return fetchBaseQuery({
    baseUrl: `${url}`,
    prepareHeaders: headers => {
      const token = localStorage.getItem('ndx_user_token');
      const deviceId = localStorage.getItem('inspection_deviceId');
      const agency = localStorage.getItem('current-fbo');
      const language = localStorage.getItem('language');

      if (token && deviceId) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('time', String(Date.now()));
        headers.set('DeviceId', deviceId);
        if (!headers.has('agency')) {
          headers.set('agency', agency);
        }
        headers.set('accept-language', language);
      } else {
        window.location.href = '/login';
      }
      headers.set('accept', `application/json`);
      if (!headers.has('agency')) {
        headers.set('agency', localStorage.getItem('current-fbo'));
      }
      headers.set('DeviceType', 'web');
      headers.set('AppVersion', '1.0.0');
      headers.set('AppType', 'web');

      return headers;
    },
  });
};

export const fetchAndStoreDeviceId = async (
  apiUrl = import.meta.env.VITE_API_URL,
) => {
  const deviceId = localStorage.getItem('inspection_deviceId');
  const language = localStorage.getItem('language');
  let config = {
    headers: {
      AppVersion: '1.0.0',
      AppType: 'web',
      DeviceType: 'web',
      'accept-language': language,
    },
  };

  if (!deviceId) {
    try {
      const response = await axios.get(`${apiUrl}create-device-uid`, config);

      if (response.data && response.data.uid) {
        localStorage.setItem('inspection_deviceId', response.data.uid);
        return response.data.uid;
      } else {
        console.error('Device ID not found in the response');
        return null;
      }
    } catch (error) {
      console.error('Error fetching Device ID:', error);
      return null;
    }
  }
};
